/**
 * Normalize an id (a Neo4j GUID or a route segment) for case- and whitespace-insensitive
 * comparison. Route-derived ids and SignalR/event ids can differ in casing/padding, so anything
 * that matches them against each other must normalize both sides first.
 */
export function normalizeId(id: string): string {
  return id.trim().toLowerCase();
}
